import React from 'react';
import { Award } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Certifications = () => {
  const { t } = useTranslation();
  
  const certifications = [
    {
      id: 1,
      key: 'ctb',
      image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/91jmkvs2_CTBB%2BLOGO.png"
    },
    {
      id: 2,
      key: 'carbon',
      image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/9d81abi2_HUELLA%20CARBONO%20copia.png"
    },
    {
      id: 3,
      key: 'pine',
      image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/0vs1u2uz_logo%20PSB%20copia.png"
    },
    {
      id: 4,
      key: 'pefc',
      image: "https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/ni9cn3d0_PEFC%20CMV%20copia.png"
    }
  ];
  
  return (
    <section className="py-16 md:py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-cmv-green font-semibold text-sm uppercase tracking-wider">
            {t('certifications.label')}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-4 md:mb-6">
            {t('certifications.title')}
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto">
            {t('certifications.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 max-w-7xl mx-auto">
          {certifications.map((cert) => (
            <div
              key={cert.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group"
            >
              {/* Certificate Image */}
              <div className="relative h-48 md:h-56 bg-gray-100 flex items-center justify-center p-6 overflow-hidden">
                <img
                  src={cert.image}
                  alt={t(`certifications.items.${cert.key}.name`)}
                  className="max-w-full max-h-full object-contain transition-transform duration-500 group-hover:scale-110"
                />
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="flex items-center gap-2 mb-3">
                  <Award className="text-cmv-green flex-shrink-0" size={20} />
                  <h3 className="text-lg md:text-xl font-bold text-gray-900">
                    {t(`certifications.items.${cert.key}.name`)}
                  </h3>
                </div>
                
                <h4 className="text-sm font-semibold text-cmv-green mb-3">
                  {t(`certifications.items.${cert.key}.title`)}
                </h4>
                
                <p className="text-sm text-gray-600 leading-relaxed">
                  {t(`certifications.items.${cert.key}.description`)}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 md:mt-16 text-center">
          <div className="inline-flex items-center gap-3 px-6 py-3 bg-cmv-green/10 rounded-full">
            <Award className="text-cmv-green" size={24} />
            <p className="text-gray-700 font-medium">
              {t('certifications.bottomText')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
